import { IotError } from "@core/domain/errors/iot.error.ts";
import { t } from "i18next";
import type { Result } from "neverthrow";
import * as z from "zod";

const recuperableErrorBrandSchema = z
    .literal("RecuperableError")
    .brand<"RecuperableError">();

export class RecuperableModelError<Class> extends IotError {
    readonly _brand = recuperableErrorBrandSchema;

    readonly recuperable: true = true as const;

    constructor(
        // TODO NAMING?
        readonly instance: InferPrivateInstance<Class>,
        readonly errors: z.ZodError<ExtractProps<Class>>,
    ) {
        super(t("error:core.modelError.recuperableModelError"));

        Object.setPrototypeOf(this, RecuperableModelError.prototype);
    }
}

const nonRecuperableErrorBrandSchema = z
    .literal("NonRecuperableError")
    .brand<"NonRecuperableError">();

export class NonRecuperableModelError extends IotError {
    readonly _brand = nonRecuperableErrorBrandSchema;

    readonly recuperable: false = false as const;

    constructor() {
        super(t("error:core.modelError.nonRecuperableModelError"));

        Object.setPrototypeOf(this, NonRecuperableModelError.prototype);
    }
}

type InferPrivateInstance<Class> = Class extends { prototype: infer P }
    ? P
    : never;

type ExtractProps<Class> = Class extends {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    validate: (props: any) => Result<infer P, any>;
}
    ? P
    : never;

export interface PartialValid<Class> {
    validProps: Partial<ExtractProps<Class>>;
    errors: z.ZodError<ExtractProps<Class>>;
}

export type ModelError<Class> =
    RecuperableModelError<Class> | NonRecuperableModelError;
